import { useContext, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi'

export default function ProductInfo({val, inx}) {
    const {accent_color, primary_color} = useContext(AppContext);
    const [isHovered, setIsHovered] = useState(false);
    const [description, setDescription] = useState('');
    // when the mouse hover the "i" sign returns a description div
    const handleMouseEnter = () => {
      setIsHovered(true);
      setDescription(val.desc);
    };
    // when the mouse leave the "i" sign the div dissapear
    const handleMouseLeave = () => {
      setIsHovered(false);
    };
  return (
    <div>
        <div id={`moreInfo_${inx}`} style={{backgroundColor:accent_color, color:primary_color}} className='moreInfo' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>i</div>
        <div>
            {isHovered &&(
            <div dir='rtl' style={{position: 'absolute', top: 50, right: 0, backgroundColor:accent_color, color:primary_color, fontWeight:"bold", padding: '30px', border: '1px solid gray', borderRadius: '10px', zIndex:10000}}>
                {description.length > 140 ? `${description.slice(0,140).trim()}...` : description.trim()}
            </div>)}
        </div>
    </div>
  )
}
